import React from 'react'
import { Popup, Icon } from 'semantic-ui-react'
import { useAppSelector } from 'redux/hooks'

type Props = {}

const DeckDate = ({}: Props) => {
  const updatedAt = useAppSelector(state => state.deck.updatedAt)
  const createdAt = useAppSelector(state => state.deck.createdAt)

  return (
    <Popup
      position="bottom right"
      content={
        <div>
          Created: {new Date(createdAt).toLocaleDateString()}
          <br />
          Updated: {new Date(updatedAt).toLocaleDateString()}
        </div>
      }
      trigger={
        <div style={{ whiteSpace: 'nowrap' }}>
          <Icon name="calendar" /> {new Date(updatedAt).toLocaleDateString()} <Icon name="chevron down" />
        </div>
      }
    />
  )
}

export default DeckDate
